import { isObject } from ".";

// Deeply converts keys in an object to snake_case
export const snakeCaseKeys = (object: Record<string, unknown>) =>
  Object.entries(object || {}).reduce(
    (acc: Record<string, unknown>, [key, value]): Record<string, unknown> => {
      const newKey = camelToSnakeCase(key);

      if (Array.isArray(value) && value.every(isObject)) {
        return {
          ...acc,
          [newKey]: value.map(v => snakeCaseKeys(v)),
        };
      }

      if (isObject(value)) {
        return {
          ...acc,
          [newKey]: snakeCaseKeys(value),
        };
      }

      return {
        ...acc,
        [newKey]: value,
      };
    },
    {},
  );

export const snakeCase = (text = ""): string =>
  text.toLowerCase().replace(/ /g, "_");

export const camelToSnakeCase = (text: string) =>
  text.charAt(0).toLowerCase() +
  text
    .slice(1)
    .replace(/(\[.*?\])|[A-Z]/g, (match, group) =>
      group ? match : `_${match.toLowerCase()}`,
    );
